import React from 'react';
import Image from '@jetshop/ui/Image';
import { styled } from 'linaria/react';
import { theme } from '../Theming/Theming';
import { BreadcrumbsWrapper } from '../Layout/BreadcrumbsWrapper';
import { PagePadding } from '../Layout/MaxWidth';
import TextContent from '../ui/TextContent';

const BlogHeaderWrapper = styled('div')`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  margin-bottom: 2rem;
  .blog-header-title {
    font-size: 3rem;
    text-transform: none;
    margin: 0 0 1rem 0;
    ${theme.below.md} {
      font-size: 2rem;
    }
  }
  .grid-content {
    overflow: hidden;
    .blog-image-wrapper {
      float: left;
      width: 33%;
      margin-right: 1rem;
      margin-bottom: 1rem;
      ${theme.below.md} {
        float: none;
        width: 100%;
      }
    }
    .blog-article-content {
    }
    .profile-info {
      padding: 0;
      float: left;
      clear: left;
      width: 33%;
      margin-right: 1rem;
      margin-bottom: 1rem;
      ${theme.below.md} {
        float: none;
        width: 100%;
      }
    }
    .questions {
      padding: 0;
      h3 {
        color: ${theme.colors.primary};
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
`;

const BlogHeaderProfile = ({ category, breadcrumbProps }) => {
  return (
    <PagePadding>
      <BlogHeaderWrapper
        className="blog-header-wrapper"
        data-hasimage={category.images ? true : false}
      >
        <BreadcrumbsWrapper {...breadcrumbProps} />
        <h1 className="blog-header-title">
          {category.head ? category.head.title : category.name}
        </h1>
        <div className="grid-content">
          {category.images && (
            <div className="blog-image-wrapper">
              <Image
                src={category.images}
                sizes={[1, 1, 1, 500]}
                aspect="1:1"
                title={category.name}
                alt={category.name}
                crop={true}
                cover
                className="blog-image"
              />
            </div>
          )}
          {category.content && (
            <div className="blog-article-content">
              <TextContent content={category.content} />
            </div>
          )}
        </div>
      </BlogHeaderWrapper>
    </PagePadding>
  );
};

export default BlogHeaderProfile;
